import { render, staticRenderFns } from "./peie.vue?vue&type=template&id=678f021e&scoped=true"
import script from "./peie.vue?vue&type=script&lang=js"
export * from "./peie.vue?vue&type=script&lang=js"
import style0 from "./peie.vue?vue&type=style&index=0&id=678f021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f021e",
  null
  
)

export default component.exports